import { api } from '../../../lib/api.js';

/**
 * Fetches the list of enrolled courses for the current user.
 * GET {VITE_API_URL}/v1/courses.
 *
 * NB: legacy code targets `mycourse`, but `/v1/mycourse` 404s on the current
 * backend; `/v1/courses` is what's actually live. Confirmed via curl 2026-05-21.
 *
 * Success shape: { status: "success", code: 200, data: [...courses] }
 * Note `status` is a string here, not boolean — differs from /v1/login.
 */
export async function fetchCoursesList() {
  const res = await api.request({ url: 'courses', method: 'GET' });
  return res.data;
}

/**
 * Legacy MySTEP bootstrap exposes global media flags such as
 * `jwplayer_status` and `jw_seek_disabled_status`.
 */
export async function fetchMyStepMediaSettings() {
  const res = await api.request({ url: 'mystep', method: 'GET' });
  return res.data;
}

/**
 * Fetches detail for a single course.
 * Mirrors the legacy `courses/:courseId` endpoint (GET {VITE_API_URL}/v1/courses/:courseId).
 *
 * Success shape:
 *   { status: true, code: 200, data: { coursedetails: {...}, continue: {...}, current_unit: '...' } }
 *
 * @param {string|number} courseId
 */
export async function fetchCourseDetail(courseId) {
  const res = await api.request({ url: `courses/${courseId}`, method: 'GET' });
  return res.data;
}

/**
 * Switch the server-side active course. Mirrors legacy's POST /v1/courses
 * (apps/legacy/src/redux/changeCourse/changeCourse.sagas.js). Fired from
 * handleFetchCourseDetail in parallel with the GET fetch — without this,
 * the backend rejects subsequent startAttempt calls with
 * `404 "Not your active course. Please change course."` whenever the
 * requested course differs from the user's server-side activeCourseId.
 *
 * Users only reach purchased non-expired courses, so this should always
 * succeed in normal flow. Failures are logged but don't block detail render.
 *
 * @param {string|number} courseId
 * @returns success envelope { status, code, message? }
 */
export async function activateCourse(courseId) {
  const res = await api.request({
    url: 'courses',
    method: 'POST',
    data: { course_id: String(courseId) },
  });
  return res.data;
}
